import { Stack, Typography, IconButton, Tooltip } from '@mui/material';
import { DriveFileRenameOutline, Settings } from '@mui/icons-material';

interface DeterministicTitleProps {
  onOpenSettings?: () => void;
  title?: string;
}

export const DeterministicTitle = ({
  onOpenSettings,
  title = 'Manage File Name',
}: DeterministicTitleProps) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between">
    <Typography
      variant="subtitle1"
      fontWeight={600}
      sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}
    >
      <DriveFileRenameOutline sx={{ fontSize: '20px', color: 'text.secondary' }} />
      {title}
    </Typography>
    {onOpenSettings && (
      <Tooltip title="Configure naming templates">
        <IconButton onClick={onOpenSettings} sx={{ p: '3px', m: -0.3125 }}>
          <Settings sx={{ fontSize: '24px', color: 'text.disabled' }} />
        </IconButton>
      </Tooltip>
    )}
  </Stack>
);
